// extracted by mini-css-extract-plugin
module.exports = {"container":"container-xgo6N","svg":"svg-3DFds","hitTarget":"hitTarget-2WReI"};